export const routes = {
  dashboard: { path: "/dashboard" },

  leads: {
    path: "/leads",
    lead: { path: (leadId: string) => `/leads/${leadId}` },
  },

  "lead-assignment": { path: "/lead-assignment" },
  onboarding: { path: "/onboarding" },
  "quote-enroll": { path: "/quote-enroll" },
  "live-transfer": { path: "/live-transfer" },

  dialer: { path: "/dialer" },
  communication: { path: "/communication" },
  fax: { path: "/fax" },
  resources: { path: "/resources" },
  appointments: { path: "/appointments" },
  reminders: { path: "/reminders" },
  leaderboard: { path: "/leaderboard" },
  rewards: { path: "/agent-rewards" },
  routes: {
    path: "/routes",
    detail: { path: (routeId: string) => `/routes/${routeId}` },
  },
  settings: { path: "/settings" },
  profile: { path: "/profile" },
  "admin-panel": { path: "/admin-panel" },
  "ai-calling": { path: "/ai-calling" },
  // "Marketing" tab; /marketing itself is the public marketing-partner portal (own JWT auth).
  marketing: { path: "/campaigns" },
  "team-chat": { path: "/team-chat" },
  forum: { path: "/forum" },
  training: { path: "/training" },
  compliance: {
    path: "/compliance",
    dashboard: { path: "/compliance" },
    frameworks: { 
      path: "/compliance/frameworks",
      framework: { path: (id: string) => `/compliance/frameworks/${id}` }
    },
    controls: { 
      path: "/compliance/controls",
      control: { path: (id: string) => `/compliance/controls/${id}` }
    },
    evidence: { 
      path: "/compliance/evidence",
      evidence: { path: (id: string) => `/compliance/evidence/${id}` }
    },
    reports: { path: "/compliance/reports" },
    alerts: { path: "/compliance/alerts" }
  },

  auth: {
    signIn: {
      path: "/auth/sign-in",
      "2fa": { path: "/auth/sign-in/2fa" },
    },

    signUp: { path: "/auth/sign-up" },
    resetPassword: { path: "/auth/reset-password" },
    changeEmail: { path: "/auth/change-email" },
  },
};
